import { Collapse } from 'bootstrap';
import PageLoadedQueue from "./PageLoadedQueue";

class Register {
    protected form: HTMLFormElement;

    protected pageOne: HTMLDivElement;
    protected pageTwo: HTMLDivElement;
    protected pageThree: HTMLDivElement;
    protected pageFour: HTMLDivElement;
    protected pageFive: HTMLDivElement;
    protected pageError: HTMLDivElement;

    protected collapsePageOne: Collapse;
    protected collapsePageTwo: Collapse;
    protected collapsePageThree: Collapse;
    protected collapsePageFour: Collapse;
    protected collapsePageFive: Collapse;
    protected collapsePageError: Collapse;

    protected nextStepPageOne: HTMLButtonElement;
    protected nextStepPageTwo: HTMLButtonElement;
    protected nextStepPageThree: HTMLButtonElement;
    protected nextStepPageFour: HTMLButtonElement;

    protected previousStepPageTwo: HTMLButtonElement;
    protected previousStepPageThree: HTMLButtonElement;
    protected previousStepPageFour: HTMLButtonElement;

    protected addQuestionButton: HTMLButtonElement;
    protected targetQuestion: HTMLDivElement;
    protected questionTemplate: HTMLTemplateElement;

    protected firstname: HTMLInputElement;
    protected lastname: HTMLInputElement;
    protected email: HTMLInputElement;
    protected dateOfBirth: HTMLInputElement;

    protected workType: HTMLSelectElement;
    protected expertDescription: HTMLTextAreaElement;
    protected additionalWorkTypes: HTMLInputElement;

    protected questions: Map<number, HTMLInputElement> = new Map();
    static readonly MAX_QUESTIONS = 10;

    protected terms: HTMLInputElement;

    protected submit: HTMLButtonElement;

    constructor(formElement: HTMLFormElement) {
        this.form = formElement;
        this.pageOne = formElement.querySelector('#register-step-1');
        this.pageTwo = formElement.querySelector('#register-step-2');
        this.pageThree = formElement.querySelector('#register-step-3');
        this.pageFour = formElement.querySelector('#register-step-4');
        this.pageFive = formElement.querySelector('#register-step-5');
        this.pageError = formElement.querySelector('#register-step-error');

        this.collapsePageOne = Collapse.getOrCreateInstance(this.pageOne, {
            toggle: false
        });
        this.collapsePageTwo = Collapse.getOrCreateInstance(this.pageTwo, {
            toggle: false
        });
        this.collapsePageThree = Collapse.getOrCreateInstance(this.pageThree, {
            toggle: false
        });
        this.collapsePageFour = Collapse.getOrCreateInstance(this.pageFour, {
            toggle: false
        });
        this.collapsePageFive = Collapse.getOrCreateInstance(this.pageFive, {
            toggle: false
        });
        this.collapsePageError = Collapse.getOrCreateInstance(this.pageError, {
            toggle: false
        });

        this.nextStepPageOne = this.pageOne.querySelector('.register-next-step');
        this.nextStepPageTwo = this.pageTwo.querySelector('.register-next-step');
        this.nextStepPageThree = this.pageThree.querySelector('.register-next-step');
        this.nextStepPageFour = this.pageFour.querySelector('.register-next-step');

        this.previousStepPageTwo = this.pageTwo.querySelector('.register-previous-step');
        this.previousStepPageThree = this.pageThree.querySelector('.register-previous-step');
        this.previousStepPageFour = this.pageFour.querySelector('.register-previous-step');

        this.collapsePageOne.show();
        this.collapsePageTwo.hide();
        this.collapsePageThree.hide();
        this.collapsePageFour.hide();
        this.collapsePageFive.hide();
        this.collapsePageError.hide();

        // page-1
        this.firstname = formElement.querySelector('input[name="firstname"]');
        this.lastname = formElement.querySelector('input[name="lastname"]');
        this.email = formElement.querySelector('input[name="email"]');
        this.dateOfBirth = formElement.querySelector('input[name="dateOfBirth"]');

        // page-2
        this.workType = formElement.querySelector('select[name="workType"]');
        this.expertDescription = formElement.querySelector('textarea[name="expertDescription"]');
        this.additionalWorkTypes = formElement.querySelector('input[name="additionalWorkTypes"]');

        // page-3
        this.questions.set(1, formElement.querySelector('input[name="questions[1]"]'));

        this.addQuestionButton = formElement.querySelector('button[data-register-question="add"]');
        this.targetQuestion = formElement.querySelector('[data-register-question="target"]');
        this.questionTemplate = formElement.querySelector('template[id="add-additional-question"]');

        // page-4
        this.terms = formElement.querySelector('input[name="terms"]');

        this.validationAndNavigation();

        this.addQuestionButton.addEventListener('click', this.addNewQuestion, {passive: true});

        this.form.addEventListener('submit', (e) => {
            e.preventDefault();

            if (
                this.validatePageOne()
                && this.validatePageTwo()
                && this.validatePageThree()
                && this.validatePageFour()
            ) {
                this.submitForm();
            }
        });
    }

    /**
     * Validation and navigation
     */
    protected validationAndNavigation = () => {
        this.nextStepPageOne.addEventListener('click', () => {
            if (this.validatePageOne()) {
                this.collapsePageOne.hide();
                this.collapsePageTwo.show();
                this.collapsePageThree.hide();
                this.collapsePageFour.hide();
                this.collapsePageFive.hide();
                this.collapsePageError.hide();
            }
        });

        this.nextStepPageTwo.addEventListener('click', () => {
            if (this.validatePageTwo()) {
                this.collapsePageOne.hide();
                this.collapsePageTwo.hide();
                this.collapsePageThree.show();
                this.collapsePageFour.hide();
                this.collapsePageFive.hide();
                this.collapsePageError.hide();
            }
        });

        this.nextStepPageThree.addEventListener('click', () => {
            if (this.validatePageThree()) {
                this.collapsePageOne.hide();
                this.collapsePageTwo.hide();
                this.collapsePageThree.hide();
                this.collapsePageFour.show();
                this.collapsePageFive.hide();
                this.collapsePageError.hide();
            }
        });

        this.nextStepPageFour.addEventListener('click', () => {
            this.validatePageFour();
        });

        this.previousStepPageTwo.addEventListener('click', () => {
            this.collapsePageOne.show();
            this.collapsePageTwo.hide();
            this.collapsePageThree.hide();
            this.collapsePageFour.hide();
            this.collapsePageFive.hide();
            this.collapsePageError.hide();
        });

        this.previousStepPageThree.addEventListener('click', () => {
            this.collapsePageOne.hide();
            this.collapsePageTwo.show();
            this.collapsePageThree.hide();
            this.collapsePageFour.hide();
            this.collapsePageFive.hide();
            this.collapsePageError.hide();
        });

        this.previousStepPageFour.addEventListener('click', () => {
            this.collapsePageOne.hide();
            this.collapsePageTwo.hide();
            this.collapsePageThree.show();
            this.collapsePageFour.hide();
            this.collapsePageFive.hide();
            this.collapsePageError.hide();
        });
    }

    /**
     * Switch invalid if value is set
     *
     * @param {HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement} element
     * @returns {boolean}
     */
    protected switchInvalidIfValueIsSet = (element: HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement) => {
        if (element.value === '') {
            element.classList.add('is-invalid');

            return false;
        } else {
            element.classList.remove('is-invalid');

            return true;
        }
    }

    /**
     * Validate page one
     *
     * @returns {boolean}
     */
    protected validatePageOne = (): boolean => {
        this.pageOne.classList.add('was-validated');

        let success = 0;
        success += this.switchInvalidIfValueIsSet(this.firstname) ? 1 : 0;
        success += this.switchInvalidIfValueIsSet(this.lastname) ? 1 : 0;
        success += this.switchInvalidIfValueIsSet(this.email) ? 1 : 0;
        success += this.switchInvalidIfValueIsSet(this.dateOfBirth) ? 1 : 0;

        return success === 4;
    }

    /**
     * Validate page two
     *
     * @returns {boolean}
     */
    protected validatePageTwo = (): boolean => {
        this.pageTwo.classList.add('was-validated');

        let success = 0;
        success += this.switchInvalidIfValueIsSet(this.workType) ? 1 : 0;
        success += this.switchInvalidIfValueIsSet(this.expertDescription) ? 1 : 0;
        success += this.switchInvalidIfValueIsSet(this.additionalWorkTypes) ? 1 : 1;

        return success === 3;
    }

    /**
     * Validate page three
     *
     * @returns {boolean}
     */
    protected validatePageThree = (): boolean => {
        this.pageThree.classList.add('was-validated');

        let success = 0;
        this.questions.forEach((question) => {
            success += this.switchInvalidIfValueIsSet(question) ? 1 : 0;
        });

        return success === this.questions.size;
    }

    /**
     * Validate page four
     *
     * @returns {boolean}
     */
    protected validatePageFour = (): boolean => {
        this.pageFour.classList.add('was-validated');

        if (this.terms.checked) {
            this.terms.classList.remove('is-invalid');

            return true;
        }

        this.terms.classList.add('is-invalid');

        return false;
    }

    /**
     * Add new question
     */
    protected addNewQuestion = () => {
        const { addQuestionButton, targetQuestion, questionTemplate } = this;
        let counter = this.questions.size;

        if (counter < Register.MAX_QUESTIONS) {
            counter++;

            const template = questionTemplate.content.cloneNode(true);
            const formElement = template.querySelector('.form-floating');

            formElement.querySelector('input').setAttribute('id', `question-${counter}`);
            formElement.querySelector('input').setAttribute('name', `question[${counter}]`);
            formElement.querySelector('label').setAttribute('for', `question-${counter}`);

            targetQuestion.appendChild(formElement);

            this.questions.set(counter, formElement.querySelector('input'));

            addQuestionButton.textContent = `Weitere Frage hinzufügen (${counter}/10)`;
        }

        if (counter >= Register.MAX_QUESTIONS) {
            addQuestionButton.disabled = true;
            addQuestionButton.classList.add('disabled');
        }
    }

    /**
     * Submit form
     */
    protected submitForm = () => {
        const { form } = this;

        const formData = new FormData(form);

        const data = {
            firstname: formData.get('firstname'),
            lastname: formData.get('lastname'),
            email: formData.get('email'),
            dateOfBirth: formData.get('dateOfBirth'),
            workType: formData.get('workType'),
            expertDescription: formData.get('expertDescription'),
            additionalWorkTypes: formData.get('additionalWorkTypes'),
            questions: {},
            terms: formData.get('terms'),
        };

        this.questions.forEach((question, key) => {
            data.questions[key] = question.value;
        });

        fetch(form.action, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    this.collapsePageOne.hide();
                    this.collapsePageTwo.hide();
                    this.collapsePageThree.hide();
                    this.collapsePageFour.hide();
                    this.collapsePageFive.show();
                    this.collapsePageError.hide();
                } else {
                    console.error(data);
                    this.collapsePageOne.hide();
                    this.collapsePageTwo.hide();
                    this.collapsePageThree.hide();
                    this.collapsePageFour.hide();
                    this.collapsePageFive.hide();
                    this.collapsePageError.show();
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                this.collapsePageOne.hide();
                this.collapsePageTwo.hide();
                this.collapsePageThree.hide();
                this.collapsePageFour.hide();
                this.collapsePageFive.hide();
                this.collapsePageError.show();
            });
    }

    public static defaultInit = () => {
        const formElement: HTMLFormElement = document.querySelector('form[name="register"]');

        if (formElement) {
            new Register(formElement);
        }
    }
}

PageLoadedQueue.addFunction(Register.defaultInit);
